import { DocletHostMedia, MediaBlockProps } from '../../types'

export interface Playable {
  // The file to play, or null while there isn't one yet
  src: string | null
  // A video Vimeo is still transcoding: show the "processing" placeholder
  processing: boolean
  /**
   * Vimeo couldn't transcode it, or it's gone (deleted or made private): the
   * page leaves it out, and the builder asks for a replacement
   */
  failed: boolean
}

/**
 * What a Media block plays. Its host media record wins: that's the current
 * file link (the data-extraction job refreshes it and picks the right
 * resolution) and the transcoding status. The link saved on the block is only
 * a fallback for when the record isn't available.
 */
export const playableMedia = (
  props: Pick<MediaBlockProps, 'src' | 'hostMediaId'>,
  records: Record<string, DocletHostMedia>
): Playable => {
  const record = props.hostMediaId ? records[props.hostMediaId] : undefined
  if (!record) {
    return { src: props.src, processing: !props.src, failed: false }
  }
  if (record.transcode === 'processing') {
    return { src: null, processing: true, failed: false }
  }
  // Any link left over (on the record or the block) is dead too
  if (record.transcode === 'error') {
    return { src: null, processing: false, failed: true }
  }
  const src = record.url || props.src
  return { src, processing: !src, failed: false }
}
